/*
	Создание новой сессии (чата)
*/
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createSession } from "../../../../../../../../../shared/api/sessions";

// Функция для создания новой сессии
export const fetchCreateSession = async (body: {
	user_id: string;
	title?: string | null;
}) => {
	const data = await createSession(body);
	return data;
};

// Сброс кэша списка сессий
export const useCreateSession = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: fetchCreateSession,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["sessions-data"] });
		},
	});
};
